import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Hidden, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import InputIcon from '@material-ui/icons/Input';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none'
  },
  flexGrow: {
    flexGrow: 1
  },
  rightSection: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  },
  logo: {
    height: 40,
    width: 'auto',
    objectFit: 'contain',
    display: 'block'
  }
}));

const handleLogout = history => () => {
  localStorage.removeItem('access-jwt');
  history.push('/sign-in');
};

const Topbar = props => {
  const { history, className, onSidebarOpen, ...rest } = props;
  const classes = useStyles();

  return (
    <AppBar {...rest} className={clsx(classes.root, className)}>
      <Toolbar>
        <div className={classes.flexGrow} />
        <RouterLink to="/">
          <img
            className={classes.logo}
            alt="Industria y Ambiente"
            src="/images/logos/iya-nuevologo_nobg.png"
          />
        </RouterLink>
        <div className={classes.rightSection}>
          <Hidden mdDown>
            <IconButton onClick={handleLogout(history)} className={classes.signOutButton} color="inherit">
              <InputIcon />
            </IconButton>
          </Hidden>
          <Hidden lgUp>
            <IconButton color="inherit" onClick={onSidebarOpen}>
              <MenuIcon />
            </IconButton>
          </Hidden>
        </div>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  history: PropTypes.object,
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
